export const EVENT_TEMPLATES = [
  {
    id: 'birthday',
    name: 'Birthday',
    icon: '🎂',
    description: 'Celebrate with reminders and a group message.',
    preset: {
      eventType: 'ATTENDANCE',
      category: 'SOCIAL',
      responsePolicy: {
        type: 'RSVP',
        rsvpFields: {
          guestCount: { enabled: true, required: true },
          guestNames: { enabled: true, required: true },
          guestAges: { enabled: true, required: false },
          foodPreference: { enabled: true, required: true },
          drinkPreference: { enabled: true, required: true },
        },
      },
      reminderPolicy: { enabled: true, offsets: ['1d', '1h'] },
      completionActions: [{ type: 'SEND_CONGRATULATIONS' }],
    },
  },
  {
    id: 'expense-tracking',
    name: 'Expense tracking',
    icon: '🧾',
    description: 'Log purchases with item, amount, place, paid/udhaar, and photos.',
    preset: {
      eventType: 'EXPENSE_TRACKING',
      category: 'FINANCE',
      responsePolicy: { type: 'NONE' },
      configuration: {
        currency: 'INR',
        whoCanAddExpenses: 'ALL',
        fields: {
          item: { enabled: true, required: true },
          itemCategory: { enabled: true, required: false },
          amount: { enabled: true, required: true },
          boughtPlace: { enabled: true, required: true },
          paymentStatus: { enabled: true, required: true },
          image: { enabled: true, required: false },
        },
      },
    },
  },
  {
    id: 'trip',
    name: 'Trip',
    icon: '✈️',
    description: 'Participants + poll + expense sharing + reminders.',
    preset: {
      eventType: 'SPLITWISE',
      category: 'SOCIAL',
      responsePolicy: { type: 'ACCEPT_REJECT' },
      configuration: { currency: 'INR', splitMethod: 'EQUAL' },
      reminderPolicy: { enabled: true, offsets: ['1d'] },
      completionActions: [{ type: 'SETTLEMENT' }, { type: 'SEND_MESSAGE' }],
    },
  },
  {
    id: 'dinner',
    name: 'Dinner',
    icon: '🍽️',
    description: 'Poll for restaurant + expense split.',
    preset: {
      eventType: 'POLL',
      category: 'SOCIAL',
      responsePolicy: { type: 'POLL', allowMultiple: false, anonymous: false },
      configuration: { question: 'Which restaurant should we choose?', options: ['Restaurant A', 'Restaurant B', 'Restaurant C'] },
      completionActions: [{ type: 'CALCULATE_RESULT' }],
    },
  },
  {
    id: 'meeting',
    name: 'Meeting',
    icon: '📅',
    description: 'RSVP meeting with reminders.',
    preset: {
      eventType: 'MEETING',
      category: 'WORK',
      responsePolicy: { type: 'ACCEPT_REJECT' },
      reminderPolicy: { enabled: true, offsets: ['30m', '10m'] },
      location: { locationType: 'ONLINE' },
    },
  },
  {
    id: 'attendance',
    name: 'Attendance',
    icon: '✅',
    description: 'Track attendance with grace period.',
    preset: {
      eventType: 'ATTENDANCE',
      category: 'WORK',
      configuration: { mode: 'CHECK_IN_OUT', gracePeriodMinutes: 15, lateThresholdMinutes: 15 },
      completionActions: [{ type: 'UPDATE_ATTENDANCE' }, { type: 'GENERATE_REPORT' }],
    },
  },
  {
    id: 'poll',
    name: 'Poll',
    icon: '📊',
    description: 'Quick poll with deadline.',
    preset: {
      eventType: 'POLL',
      category: 'WORK',
      responsePolicy: { type: 'POLL', allowMultiple: false },
      configuration: { question: '', options: ['Option 1', 'Option 2'] },
    },
  },
  {
    id: 'expense',
    name: 'Expense Sharing',
    icon: '💸',
    description: 'Split expenses and settle up.',
    preset: {
      eventType: 'SPLITWISE',
      category: 'FINANCE',
      configuration: {
        currency: 'INR',
        splitMethod: 'EQUAL',
        whoCanAddExpenses: 'ALL',
        fields: { image: { enabled: true, required: false } },
      },
      completionActions: [{ type: 'SETTLEMENT' }],
    },
  },
  {
    id: 'team-activity',
    name: 'Team Activity',
    icon: '🏃',
    description: 'Team outing with RSVP and follow-up task.',
    preset: {
      eventType: 'TASK',
      category: 'WORK',
      responsePolicy: { type: 'YES_NO_MAYBE' },
      completionActions: [{ type: 'CREATE_TASK' }, { type: 'SEND_MESSAGE' }],
    },
  },
];

export const getEventTemplate = (id) => EVENT_TEMPLATES.find((t) => t.id === id);
